import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-nan.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CardFooter',
  props: {
    exportedAt: {
      type: [Date, String, Number],
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var exportedOnLabel = computed(function () {
      var _proxy$$i18n;
      var date = props.exportedAt instanceof Date ? props.exportedAt : new Date(props.exportedAt);
      if (Number.isNaN(date.getTime())) {
        return '';
      }
      var locale = ((_proxy$$i18n = proxy.$i18n) === null || _proxy$$i18n === void 0 ? void 0 : _proxy$$i18n.locale) === 'de' ? 'de-DE' : 'en-GB';
      return proxy.$t('exportedOn', {
        date: date.toLocaleDateString(locale)
      });
    });
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      exportedOnLabel: exportedOnLabel
    };
  }
});